// B10: a token that stops working must end the session everywhere at once, but a failed
// *login attempt* (also a 401) must not be mistaken for an expired session.
export const AUTH_EXPIRED_EVENT = "mastofa:auth-expired";

const CREDENTIAL_PATHS = ["/auth/login", "/auth/register", "/admin/login"];

export const isSessionExpiry = (error, tokenPresent) => {
  if (!tokenPresent) return false;
  if (error?.response?.status !== 401) return false;
  const url = String(error?.config?.url || "");
  return !CREDENTIAL_PATHS.some((path) => url.includes(path));
};
